import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Heading from './heading';
import theme from '../theme';
import { modularScale } from '../utils';

const ParagraphHeading = ({ componentType = 'h3', ...restProps }) => {
	return <StyledParagraphHeading componentType={componentType} {...restProps} />
};

ParagraphHeading.propTypes = {
	className: PropTypes.string,
	componentType: PropTypes.object,
	children: PropTypes.node
};

const StyledParagraphHeading = styled(Heading)`
	font-size: ${modularScale(2)};
	font-weight: ${theme.typography.heading.fontWeight};

	@media (min-width: ${theme.breakpoints.tablet}px) {
		font-size: ${modularScale(3)};
	}
`;

export default ParagraphHeading;
